export default __webpack_public_path__ + "static/companies-two-372751fb933d51b6278aa6063985fd6c.jpg";